module.exports = __webpack_public_path__ + "img/avatar-5.3e35c39b.jpg";